import * as THREE from 'three';

export class LogoMarkStrokes extends THREE.Object3D{

    //ストロークを書く
    numParticles:number=1000;
    strokes:THREE.Line;
    counter=0;

    positions   :number[];
    colors      :number[];
    scales      :number[];
    geo         :THREE.BufferGeometry;
    private mode        :string;
    material    :THREE.LineBasicMaterial;
    isDirty     :boolean=false;

    init(){

        //this.mode = Params.CONNECT_LINE;
        const positions = new Float32Array( this.numParticles * 3 );
        const colors = new Uint8Array( this.numParticles*3 );
        
        for ( let i = 0; i < this.numParticles; i++ ) {
            positions[ i*3 + 0 ] = (Math.random()-0.5)*20
            positions[ i*3 + 1 ] = (Math.random()-0.5)*20
            positions[ i*3 + 2 ] = (Math.random()-0.5)*20
            colors[ i*3 + 0 ] = 255;//Math.floor(Math.random()*255);//(Math.random()-0.5)*2000
            colors[ i*3 + 1 ] = 255;//Math.floor(Math.random()*255);//(Math.random()-0.5)*2000
            colors[ i*3 + 2 ] = 255;//Math.floor(Math.random()*255);//(Math.random()-0.5)*2000
        }

        this.geo = new THREE.BufferGeometry();
        this.geo.setAttribute('color', new THREE.Uint8BufferAttribute(colors, 3, true));
        this.geo.setAttribute( 'position', new THREE.BufferAttribute( positions, 3 ) );
        //this.geo.setAttribute( 'scale', new THREE.BufferAttribute( scales, 1 ) );

        this.material = new THREE.LineBasicMaterial({
            color:0xffffff,
            vertexColors:true,
            blending: THREE.AdditiveBlending
        });
        this.material.transparent=true;
        //this.material.opacity=0.5;
        this.strokes = new THREE.LineSegments( this.geo, this.material );
        //scene.add( particles );
        this.positions  = this.geo.attributes.position.array as number[];
        this.colors     = this.geo.attributes.color.array as number[]; 
        //this.scales = this.particles.geometry.attributes.scale.array as number[];

        this.add(this.strokes);
        this.hide();
       
    }

    show(){
        this.strokes.visible=true;
    }
    hide(){
        this.strokes.visible=false;
    }

    reset(){
        this.counter=0;
        this.strokes.visible=false;
        for ( let i = 0; i < this.positions.length; i++ ) {
            this.positions[i]=0;
        }
        this.geo.attributes.position.needsUpdate = true;
    }

    resetCount(){
        this.counter=0;
        
    }


    connectDots(
        x1:number,y1:number,z1:number,//start
        x2:number,y2:number,z2:number,//goal
        brightness:number
    ){
    
        this.isDirty=true;
        this.strokes.visible=true;
        let ratio = 0;//-Math.pow(brightness,3);
        
        //x2はゴール
        this.positions[this.counter*6+0] = x1;//x2*ratio+x1*(1-ratio);
        this.positions[this.counter*6+1] = y1;//y2*ratio+y1*(1-ratio);
        this.positions[this.counter*6+2] = 1;//z1;//z2*ratio+z1*(1-ratio);

        this.positions[this.counter*6+3] = x2;
        this.positions[this.counter*6+4] = y2;
        this.positions[this.counter*6+5] = 1;//z2;
        
        this.colors[this.counter*6+0] = 255*brightness;//255*Math.random();
        this.colors[this.counter*6+1] = 255*brightness;//255*Math.random();
        this.colors[this.counter*6+2] = 255*brightness;//255*Math.random();

        this.colors[this.counter*6+3] = 255*brightness;
        this.colors[this.counter*6+4] = 255*brightness;
        this.colors[this.counter*6+5] = 255*brightness;

        if(this.counter<this.numParticles){
            this.counter += 1;
        }else{
            console.log("stroke数を超えた")
        }
        
    }


    blink(){
        /*
        this.material.color.r = 1;
        this.material.color.g = 1;
        this.material.color.b = 1;

        gsap.to(this.material.color,{
            duration:0.5,
            r:0.5,
            g:0.5,
            b:0.5
        })*/
    }

    //pointsに従ってレンダリングします
    update(){
    
        if(this.strokes.visible && this.isDirty){
            this.geo.attributes.position.needsUpdate = true;
            this.geo.attributes.color.needsUpdate = true;
            this.isDirty=false;
        }
        this.resetCount();

    }


}